module.exports = __webpack_public_path__ + "img/bg_5.63dee43a.png";